import { render, staticRenderFns } from "./sel-ranking.vue?vue&type=template&id=4d78c4ed&scoped=true&"
import script from "./sel-ranking.vue?vue&type=script&lang=js&"
export * from "./sel-ranking.vue?vue&type=script&lang=js&"
import style0 from "./sel-ranking.vue?vue&type=style&index=0&id=4d78c4ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d78c4ed",
  null
  
)

export default component.exports